export const tr = {
    'normal-view-title': 'Reklamlara gerekli netleştirmeleri ekleyin',
    'normal-view-title-hint': 'Bazı reklamlarınız gerekli netleştirmeleri içermediği için bu öneriyi görüyorsunuz',
    'percent-value': '%{value}',
    'popup-view-title': 'Reklama gerekli netleştirmeleri ekleyin',
    'popup-view-title-hint': 'Reklamınız gerekli netleştirmeleri içermediği için bu öneriyi görüyorsunuz',
    'show-many-banner-button': '{count} reklamı görüntüle',
    'show-one-banner-button': '{count} reklamı görüntüle',
    'show-some-banner-button': '{count} reklamı görüntüle',
    'title-extension-desc1':
        "Yaptığımız araştırma sonuçlarına göre netleştirmeler, reklamın CTR'ını {value} oranında artırır.",
    'title-extension-desc2':
        'Netleştirmeler sayesinde ürün veya hizmetinizin ya da sizinle çalışmanın avantajlarını anlatabilir ve varsa özel teklifleriniz hakkında bilgi verebilirsiniz.'
};
